
<template>
    <v-dialog v-model="dialog" style="width: 100%;">
        <v-card>
            <v-container id="jobReferance" class="pdf-content">
                <div
                    style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
                    <v-col cols="3">
                        <v-img src="@/assets/logo_delta.jpg" contain height="90" />
                    </v-col>
                    <v-col cols="9" class="text-right">
                        <h2 class="mb-0">Lista de Referencia</h2>
                        <p>Geral Todos</p>
                    </v-col>
                </div>

                <v-card outlined class="pa-10">
                    <v-row v-for="job in listJobs" :key="job._id" dense>
                        <v-col cols="3">
                            <strong>Job.:</strong> {{ job.code }}
                        </v-col>
                        <v-col cols="5" >
                            <p>
                                <strong>Cliente:</strong> {{ job.clienteNome }}
                            </p>
                            <p>
                                <strong>Localidade:</strong> {{ job.cliente[0].entregaCidadeNome }}
                            </p>
                            <p>
                                <strong>Contato/Dep:</strong> {{ job.contatoComercial[0].nome }} / {{ job.contatoComercial[0].departamento }}
                            </p>
                            <p>
                                <strong>Telefone:</strong> {{ job.contatoComercial[0].telefone }}
                            </p>
                            <br>

                            <p v-for="jobIten in job.jobItens" :key="jobIten._id">
                                ({{ jobIten.quantidade  }}) {{ jobIten.descricao }}
                            </p>

                        </v-col>
                        <v-col cols="2">
                            <strong>Data.:</strong> {{ new Date(job.dataAbertura).toLocaleDateString() }}
                        </v-col>
                    </v-row>
                </v-card>
            </v-container>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" @click="$emit('cancel')">Cancelar</v-btn>   
                <v-btn color="primary" @click="exportPdf">Gerar PDF</v-btn>    
            </v-card-actions>
            
        </v-card>
    </v-dialog>
</template>

<script>
import html2pdf from 'html2pdf.js'

export default {
    name: 'JobReferenceView',
    props: ['isOpen', 'listJobs'],
    data() {
        return {
            dialog: false
        }
    },
    watch: {
        isOpen(value){
            console.log('JOB List >>> ', this.listJobs)
            this.dialog = value
        }
    },

    methods: {
        exportPdf() {
            const elemento = document.getElementById("jobReferance");
            html2pdf()
            .set({
                margin: 10,
                filename: 'Relatorio-Referencia.pdf',
                html2canvas: { scale: 2 },
                jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
            })
            .from(elemento)
            .save();
        },
    }
}
</script>

<style scoped>
.pdf-content {
  font-family: 'Arial', sans-serif;
  padding: 20px;
}

.avoid-break {
  page-break-inside: avoid;
  break-inside: avoid;
}

tr {
  page-break-inside: avoid !important;
  break-inside: avoid !important;
  font-size: 20px;
}
</style>